(function () {
  'use strict';

  var lastPathname = window.location.pathname;
  var activeFetchController = null;

  /* Move sold-out cards to the end of each product grid.
     Runs on initial load and after every "Cargar más" injection. */
  function sortByAvailability(root) {
    (root || document).querySelectorAll('.product-grid').forEach(function (grid) {
      var items = Array.prototype.slice.call(grid.children);
      var available = [];
      var soldOut = [];
      items.forEach(function (item) {
        var card = item.querySelector('.wc-product-card');
        if (card && card.dataset.available === 'false') {
          soldOut.push(item);
        } else {
          available.push(item);
        }
      });

      var sorted = available.concat(soldOut);
      var alreadySorted = sorted.every(function (el, i) { return el === items[i]; });
      /* Skip the no-op appendChild calls: each one is a childList mutation,
         and this runs inside a MutationObserver watching this same grid —
         re-appending already-in-place items would retrigger it forever. */
      if (alreadySorted) return;

      sorted.forEach(function (el) { grid.appendChild(el); });
    });
  }

  /* Re-sort when Dawn injects or replaces the product grid (filters, "Cargar más") */
  var sortDebounce;
  var observer = new MutationObserver(function () {
    clearTimeout(sortDebounce);
    sortDebounce = setTimeout(function () { sortByAvailability(document); }, 80);
  });

  /* AJAX Category Navigation */
  function initAjaxCategories() {
    // Intercept clicks on category links using event delegation
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.wc-sidebar-cats__link');
      if (!link) return;

      event.preventDefault();

      var url = link.getAttribute('href');
      if (!url || link.classList.contains('is-active')) return;

      loadCategory(url, true);
    });

    // Handle back/forward navigation
    window.addEventListener('popstate', function (event) {
      if (window.location.pathname !== lastPathname) {
        lastPathname = window.location.pathname;
        if (window.FacetFiltersForm) {
          // Sync searchParamsPrev synchronously to prevent Dawn's popstate handler from double fetching
          FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
        }
        loadCategory(window.location.href, false);
      }
    });
  }

  function loadCategory(url, updateHistory) {
    var gridContainer = document.getElementById('ProductGridContainer');
    var sidebar = document.getElementById('main-collection-filters');
    
    // 1. Calculate the target scroll position BEFORE any DOM manipulation or layout collapse.
    // This avoids scroll jumps when the grid temporarily collapses to 0 height.
    var scrollTarget = document.querySelector('.wc-cat-hero') || document.querySelector('.wc-plp-body') || gridContainer;
    var targetScrollTop = 0;
    if (scrollTarget) {
      targetScrollTop = scrollTarget.getBoundingClientRect().top + window.scrollY - 120; // 120px offset for header
      if (targetScrollTop < 0) targetScrollTop = 0;
    }

    // Add loading states
    if (gridContainer) {
      gridContainer.classList.add('wc-plp-loading');
    }
    if (sidebar) {
      sidebar.classList.add('wc-plp-loading');
    }

    // Cancelar el fetch anterior: clics rapidos podian hacer que una
    // respuesta vieja pisara a la nueva
    if (activeFetchController) activeFetchController.abort();
    activeFetchController = new AbortController();
    var fetchSignal = activeFetchController.signal;

    fetch(url, { signal: fetchSignal })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Update tracking pathname
        lastPathname = new URL(url, window.location.origin).pathname;

        // Update Page Title
        document.title = doc.title;

        // Update URL
        if (updateHistory) {
          history.pushState(null, '', url);
        }

        // 2. Update Category Hero
        var currentHero = document.querySelector('.wc-cat-hero');
        var newHero = doc.querySelector('.wc-cat-hero');
        if (currentHero && newHero) {
          currentHero.innerHTML = newHero.innerHTML;
        }

        // 3. Update Sorting Form Wrapper (which contains desktop product count)
        var currentSort = document.querySelector('.facets-vertical-sort');
        var newSort = doc.querySelector('.facets-vertical-sort');
        if (currentSort && newSort) {
          currentSort.outerHTML = newSort.outerHTML;
        }

        // 4. Update Product Grid
        var currentGrid = document.getElementById('ProductGridContainer');
        var newGrid = doc.getElementById('ProductGridContainer');
        if (currentGrid && newGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        }

        // 5. Update Sidebar (Categories + Facets Form)
        var currentSidebar = document.getElementById('main-collection-filters');
        var newSidebar = doc.getElementById('main-collection-filters');
        if (currentSidebar && newSidebar) {
          currentSidebar.innerHTML = newSidebar.innerHTML;
        }

        // 6. Explicitly update product counts to ensure they match (fallback)
        var currentCount = document.getElementById('ProductCount');
        var newCount = doc.getElementById('ProductCount');
        if (currentCount && newCount) {
          currentCount.innerHTML = newCount.innerHTML;
        }
        var currentCountDesktop = document.getElementById('ProductCountDesktop');
        var newCountDesktop = doc.getElementById('ProductCountDesktop');
        if (currentCountDesktop && newCountDesktop) {
          currentCountDesktop.innerHTML = newCountDesktop.innerHTML;
        }

        // 7. Update Dawn FacetFiltersForm state
        if (window.FacetFiltersForm) {
          FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
          FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
          FacetFiltersForm.filterData = []; // Clear filter cache to avoid old state
        }

        // Remove loading states
        if (gridContainer) {
          gridContainer.classList.remove('wc-plp-loading');
        }
        if (sidebar) {
          sidebar.classList.remove('wc-plp-loading');
        }

        // Re-sort by availability on the new grid
        sortByAvailability(document);

        // Re-sync catalogo chips and search inputs after category AJAX navigation
        if (window.wcCatalogoFilters) window.wcCatalogoFilters.refresh();

        // Smooth scroll to the pre-calculated target top
        window.scrollTo({
          top: targetScrollTop,
          behavior: 'smooth'
        });
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return; // reemplazado por un fetch mas nuevo
        console.error('Error loading category:', error);
        // Fallback to normal navigation on error
        window.location.href = url;
      });
  }

  function init() {
    sortByAvailability(document);
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      observer.observe(container, { childList: true, subtree: true });
    }
    initAjaxCategories();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
